import { useEffect } from 'react';

/*
  Sets the legacy Apple-skin variables (zinc / orange remap, --ap-*) on <html> while a project page is open.
  Only the BMS sub-item rows still use them (see the 'Legacy Apple skin' block in index.css); the page frame,
  the eight tabs and every popover use the app foundation. Remove with that block.
*/

export function useAppleProjectTheme() {
  useEffect(() => {
    const root = document.documentElement;
    root.classList.add('apple-project-active');
    return () => root.classList.remove('apple-project-active');
  }, []);
}
